export const DESKTOP_VIEWPORT = {
	width: 1920,
	height: 1080,
};

export const MOBILE_VIEWPORT = {
	width: 1280,
	height: 720,
};



// WEBPACK FOOTER //
// ./@fantasmagames/slot/src/config/config.ts